import Reviews from "@/components/Reviews";
import { motion } from "framer-motion";

export default function ReviewsPage() {
  return (
    <div data-testid="reviews-page">
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-heading text-gg-red text-xs uppercase tracking-[0.3em]">What Clients Say</motion.span>
          <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="font-heading text-2xl sm:text-3xl font-extrabold uppercase tracking-tight mt-1">Client <span className="text-gg-red">Reviews</span></motion.h1>
        </div>
      </div>
      <Reviews />
    </div>
  );
}
